import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/game.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_card = _resolveComponent("card")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.$style.container
  }, [
    _createVNode("h1", {
      class: _ctx.$style.hello
    }, "Hello.", 2),
    _createVNode("div", {
      class: _ctx.$style.logo
    }, [
      _createVNode(_component_router_link, { to: "/play" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_card, {
      class: _ctx.$style.card
    }, null, 8, ["class"])
  ], 2))
}